/** Default CDN base URL for runtime dependency scripts. */
export const DefaultRuntimeBaseUrl = "https://cdn.babylonjs.com";
/**
 * Relative paths for each runtime dependency script, appended to a base URL.
 */
export const RuntimeScriptPaths = {
    havok: "havok/HavokPhysics_umd.js",
    ammo: "ammo/ammo.js",
    recast: "recast.js",
};
//# sourceMappingURL=types.js.map